











































import Vue from "vue";
import { GroupsQuery_groups } from "@/graphql/generatedTypes/GroupsQuery";
import GROUPS_QUERY from "@/graphql/GroupsQuery.gql";
import TRAINER_GROUPS_QUERY from "@/graphql/TrainerGroupsQuery.gql";
import DELETE_GROUP_MUTATION from "@/graphql/DeleteGroupMutation.gql";
import { AuthRepository } from "@ct/auth";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import formatUtils from "@/components/FormatUtil";
import moment from "moment-timezone";

type compareFn<T = any> = (a: T, b: T) => number;

export interface TableHeader {
  text: string;
  value: string;
  align?: "start" | "center" | "end";
  sortable?: boolean;
  filterable?: boolean;
  divider?: boolean;
  class?: string | string[];
  width?: string | number;
  filter?: (value: any, search: string | null, item: any) => boolean;
  sort?: compareFn;
}

export interface FormattedGroup {
  id: string | null;
  city: string;
  trainerName: string;
  isPrivate: string;
  isVirtual: string;
  date: string;
}

export default Vue.extend({
  name: "AdminPortalGroupsTable",
  apollo: {
    groups: {
      query: GROUPS_QUERY,
      skip() {
        return AuthRepository.getCurrentUser()?.imgRole === RoleEnum.TRAINER;
      }
    },
    trainerGroups: {
      query: TRAINER_GROUPS_QUERY,
      manual: true,
      skip() {
        return AuthRepository.getCurrentUser()?.imgRole === RoleEnum.ADMIN;
      },
      result({ data, loading }) {
        if (!loading) this.groups = data.trainerGroups;
      }
    }
  },
  data() {
    return {
      headers: [
        { text: "City", value: "city" },
        { text: "Trainer", value: "trainerName" },
        { text: "Private Intro", value: "isPrivate" },
        { text: "Virtual Intro", value: "isVirtual" },
        { text: "Date", value: "date" },
        { text: "Actions", value: "action" }
      ] as TableHeader[],
      groups: [] as GroupsQuery_groups[],
      showDeleteDialog: false,
      groupToDelete: null as any,
      showArchivedGroups: false
    };
  },
  methods: {
    formatGroups(): FormattedGroup[] {
      let groups = this.groups;

      if (!this.showArchivedGroups) {
        groups = this.groups.filter(group => {
          const lastSessionDate = new Date(group.sessions[2].date || "");
          const cutOffDate = moment(lastSessionDate)
            .add("7", "d")
            .toDate();
          const today = new Date();

          if (today > cutOffDate) return;

          return group;
        });
      }

      return groups.map((group: any) => {
        return {
          id: group.id,
          city: group.city || "N/A",
          trainerName: group.trainer?.firstName || "",
          isPrivate: group.isPrivate ? "Yes" : "No",
          isVirtual: group.virtual ? "Yes" : "No",
          date: this.formatGroupDate(group) || ""
        };
      });
    },
    formatGroupDate(group: GroupsQuery_groups): string {
      if (!group.sessions) return "";

      const startDate = `${formatUtils.prettyDateShort(
        group.sessions?.[0].date || ""
      )} ${formatUtils.prettyTimeWithTimezone(group.sessions?.[0].time || "", group.sessions?.[0].timezone || "")}`;
      const endDate = `${formatUtils.prettyDateShort(
        group.sessions?.[group.sessions.length - 1].date || ""
      )} ${formatUtils.prettyTimeWithTimezone(
        group.sessions?.[group.sessions.length - 1].time || "",
        group.sessions?.[0].timezone || ""
      )}`;
      return `${startDate} - ${endDate}`;
    },
    canViewDeleteGroup(): boolean {
      if (AuthRepository.getCurrentUser()?.imgRole === RoleEnum.TRAINER) return true;
      return AuthRepository.getCurrentUser()?.imgRole === RoleEnum.ADMIN;
    },
    loadDeleteDialog(group: FormattedGroup) {
      this.groupToDelete = group;
      this.showDeleteDialog = true;
    },
    cancelDeleteDialog() {
      this.showDeleteDialog = false;
    },
    async deleteGroup() {
      this.showDeleteDialog = false;
      const groupId = this.groupToDelete?.id;

      if (!groupId) {
        return;
      }

      const result = await this.$apollo.mutate({
        mutation: DELETE_GROUP_MUTATION,
        variables: {
          id: groupId
        }
      });

      if (result.errors || result.data.deleteGroup.errors.length) {
        await this.$alertService.addAlert({
          message: "Intro could not be deleted. Please refresh and try again.",
          type: "error"
        });
      } else {
        await this.$alertService.addAlert({ message: "Intro has been deleted.", type: "success" });
        this.groups = this.groups.filter(group => group.id !== groupId);
      }
    }
  }
});
